import { useEffect, useState } from 'react'
import { setCookie } from '../../../utils/cookies'
import { getUserEmail, getUserUUID } from '../../../utils/auth'
import useSWR from 'swr'
import useService from '../../../services/hooks/useService'
import AuthenticationService from '../../../services/AuthenticationService'

export default function useSession({ initialData }) {
  const [email, setEmail] = useState(null)
  const [userUUID, setUserUUID] = useState(initialData?.UUID || null)
  const authenticationService = useService(AuthenticationService, [userUUID])
  const { data, error } = useSWR(
    () => (userUUID ? [userUUID, '/users/[uuid]?roles'] : null),
    authenticationService.findUserAndRolesByUUID,
    { fallbackData: initialData }
  )

  const signIn = (token) => {
    // Expires in 10 years
    setCookie('minex-token', token, 365 * 10)
    setUserUUID(getUserUUID())
    setEmail(getUserEmail())
  }

  const signOut = () => {
    setCookie('minex-token', '', 0)
    setUserUUID(null)
    setEmail(null)
  }

  useEffect(() => {
    const cookieUUID = getUserUUID()
    const cookieEmail = getUserEmail()
    if (cookieUUID && cookieUUID !== userUUID) {
      setUserUUID(cookieUUID)
    }
    if (cookieEmail) {
      setEmail(cookieEmail)
    }
  }, [])

  const effectiveData = data !== undefined ? data : initialData

  const loading = (!!userUUID || userUUID === undefined) && !effectiveData && !error

  const isValid = userUUID === effectiveData?.UUID

  const user = userUUID ? effectiveData : null

  return { user, isValid, email, loading, signIn, signOut }
}
